module.exports = __webpack_public_path__ + "static/media/send.ca677198.svg";